export class NoLicenseError extends Error {
  public readonly code: string = 'noLicense';

  constructor() {
    super('No valid license found');
  }
}
